export const flyOutMenu = () => {
  const menus = document.querySelectorAll("[data-wm-fly-out-menu]");

  if (menus.length < 1) {
    return;
  }

  const flyOutMenu = (currentMenu) => {
    const menu = {
      root: currentMenu,
      trigger: currentMenu.querySelector(
        ":scope > [data-wm-fly-out-menu-trigger]"
      ),
      list: currentMenu.querySelector(":scope > [data-wm-fly-out-menu-list]"),
      isVisible: false,
      id: currentMenu.id,
    };

    const toggleMenu = () => {
      if (menu.isVisible) {
        closeMenu();
      } else {
        openMenu();
      }
    };

    const handleCloseMenu = (event) => {
      if (!event.composedPath().includes(menu.root)) {
        closeMenu();
      }
    };

    const openMenu = () => {
      menu.list.hidden = false;
      menu.trigger.setAttribute("aria-expanded", "true");
      menu.isVisible = true;
      document.addEventListener("click", handleCloseMenu);
    };

    const closeMenu = () => {
      menu.list.hidden = true;
      menu.trigger.setAttribute("aria-expanded", "false");
      menu.isVisible = false;
      document.removeEventListener("click", handleCloseMenu);
    };

    const setMainTriggers = () => {
      menu.trigger.addEventListener("click", toggleMenu, false);
      setItemsBlurEvents();
    };

    const setItemsBlurEvents = () => {
      const links = menu.list.querySelectorAll(":scope > a, :scope > button");
      let timeout;

      [...links].forEach((link) => {
        if (isLinkInsideAnotherMenu(link))
          link.addEventListener(
            "focus",
            () => {
              if (timeout) {
                clearTimeout(timeout);
                timeout = null;
              }
            },
            false
          );

        link.addEventListener(
          "blur",
          () => {
            timeout = setTimeout(() => {
              if (menu.isVisible) {
                closeMenu();
              }
            }, 10);
          },
          false
        );
      });
    };

    setMainTriggers();
  };

  [...menus].forEach((_menu) => {
    flyOutMenu(_menu);
  });
};
